import { makeStyles } from '@material-ui/core'

import { lang } from '../../../../localization'
import { monitoringGridColumns } from './monitoringGrid'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    // Shared with the header — see monitoringGrid.
    gridTemplateColumns: monitoringGridColumns.base,
    '& > div': {
      minWidth: 0
    },
    alignItems: 'center',
    paddingLeft: 12,
    color: 'grey',
    marginBottom: 4,
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    },
    borderRadius: 20,
    backgroundColor: theme.palette.background.default,
    textAlign: 'left',
    height: 78,
    transition: 'background-color 0.3s ease-in-out',
    [theme.breakpoints.down(1200)]: {
      width: '1250px'
    },
    [theme.breakpoints.down(1360)]: {
      gridTemplateColumns: monitoringGridColumns.small
    },

    [theme.breakpoints.between(1360, 1800)]: {
      gridTemplateColumns: monitoringGridColumns.medium
    }
  },
  text: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    [theme.breakpoints.between(1360, 1800)]: {
      fontSize: lang === 'en' ? 13 : 12
    },
    [theme.breakpoints.down(1360)]: {
      fontSize: lang === 'en' ? 12 : 11
    },
    [theme.breakpoints.down('sm')]: { fontSize: lang === 'en' ? 14 : 12 },
    [theme.breakpoints.down(1200)]: { fontSize: lang === 'en' ? 14 : 12 }
  },
  moreIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  skeleton: {
    marginTop: '14px!important',
    marginBottom: '14px!important',
    width: '80%'
  },
  endpointURLSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  tooltipSection: {
    marginLeft: 5
  }
}))
export default useStyles
